<div
	[@formErrorSlideUpDown]="{
		value: hasErrors,
		params: { opacity: hasErrors ? 1 : 0 }
	}"
	*ngIf="!hideErrors"
	class="errorWrapper text-end"
>

	<!-- Form Validation Errors -->
	<small *ngFor="let error of errors | keyvalue; let idx = index">
		{{ getI18nString( false, 'shared.forms.errors.' + error.key ) }}
	</small>

	<!-- Optional Errors -->
	<small *ngFor="let error of errorMsg; let idx = index">
		{{ error }}
	</small>
</div>
